// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3ZR9U","label":"Labeled_label__2XbNu","divider":"Labeled_divider__2FVZZ"};